import '../../resources/css/layout/MainLayout.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import MainHeader from '../../components/frame/MainHeader';
import MainMenu from '../../components/frame/MainMenu';
import HoodListPage from '../dashboard/HoodListPage';
import HoodMonitorPage from '../dashboard/HoodMonitorPage';
import ModelListPage from '../maintenance/ModelListPage';
import AccountListPage from '../maintenance/AccountListPage';
import CloudAccountListPage from '../maintenance/CloudAccountListPage';
import CompanyInfoPage from '../maintenance/CompanyInfoPage';
import { WAIT_LOGIN, reLoginBySession } from '../../actions/login/index';
import { doActivePage } from '../../actions/menu/index';
import Loading from '../../components/common/Loading';

class MainLayout extends Component {

  isNeedReLogin = ( loginStatus ) => {
    if (loginStatus === WAIT_LOGIN) {
      const loginParams = window.sessionStorage.getItem('RangeHood.LoginParams');
      if (loginParams) {
        return true;
      }
    }
    return false;
  }

  componentDidMount() {
    const { loginStatus, reLoginBySession, match, doActivePage } = this.props;

    if (this.isNeedReLogin(loginStatus)) {
      reLoginBySession();
    }
    
    if (match.params.navName) {
      doActivePage(match.params.navName);
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { menuActivePage, history } = this.props;

    if (prevProps.menuActivePage !== menuActivePage) {
      if (menuActivePage && history) {
        history.push('/' + menuActivePage);
      }
    }
  }

  render() {
    const { loginStatus, menuMode } = this.props;
    const classMainMenu = 'area-main-menu ' + menuMode;
    const classMainContent = 'main-content ' + menuMode;
    
    // do auto re-login by session
    if (this.isNeedReLogin(loginStatus)) {
      return (
        <Loading loading={true}></Loading>
      )
    }

    return (
      <div className="main-layout">
        <Row>
          <Col sm={12}>
            <div className='main-header'>
              <MainHeader/>
            </div>
          </Col>
        </Row>
        <Row>
          <div className={ classMainMenu }>
            <MainMenu/>
          </div>
          <div className={ classMainContent }>
            <Switch>
              <Route path="/HoodList" exact component={HoodListPage} />
              <Route path="/HoodMonitor" exact component={HoodMonitorPage} />
              <Route path="/HoodModeList" exact component={ModelListPage} />
              <Route path="/AccountList" exact component={AccountListPage} />
              <Route path="/CloudAccountList" exact component={CloudAccountListPage} />
              <Route path="/CompanyInfo" exact component={CompanyInfoPage} />
            </Switch>
            {/* <ModalFrame modalStatus={modalStatus} modalMessage={modalMessage} modalRedirect={modalRedirect}/> */}
          </div>
        </Row>
    </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loginStatus: state.logindReducers.status,
    menuMode: state.menuReducers.displayMode,
    menuActivePage: state.menuReducers.activePage
  }
};

export default withRouter(connect(
  mapStateToProps,
  { reLoginBySession, doActivePage }
)(MainLayout));